import { apiSlice } from "../../app/api/apiSlice";
import { Buffer } from 'buffer'

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: 'v1/login',
                method: 'POST',
                headers: {
                    'Authorization': 'Basic ' + Buffer.from(credentials.username + ':' + credentials.password).toString('base64')
                }
            })
        })
    })
})

export const { useLoginMutation } = authApiSlice